module.exports = __webpack_public_path__ + "images/guide-71bff7b436.png";